import { apiClient, type TruckExEntity } from '@/libs/api'

export type FetchTruckQuery = {
  tenantKey: string
  truckId: number
}

export const fetchTruck = async (
  { tenantKey, truckId }: FetchTruckQuery,
  signal?: AbortSignal
): Promise<TruckExEntity> => {
  const { data } = await apiClient._tenant(tenantKey).trucks._id(truckId).$get({
    config: {
      signal
    }
  })
  return data
}
